// Central content for the Caladium Systems home page.

const img = (file) => `${process.env.PUBLIC_URL}/images/${file}`;

export const brands = [
  {
    id: 'atlhea',
    name: 'Atlhea',
    logo: img('atlhea_logo.png'),
    photo: img('Atlhea.png'),
    color: '#d9a94e',
    orbitPos: 'tl',
    orbitLabel: 'Wedding Portraits & Films',
    tagline: 'Wedding Portraits & Films',
    website: 'https://www.atlhea.in',
    blurb:
      'Capturing timeless emotions and turning your wedding moments into everlasting memories.',
    features: [
      'Wedding Photography',
      'Cinematic Films',
      'Pre-wedding Shoots',
      'Albums & Fine Art',
      'Destination Weddings',
    ],
  },
  {
    id: 'epanchang',
    name: 'ePanchang',
    logo: img('ePanchang_Logo_New.png'),
    photo: img('ePanchang.png'),
    color: '#a855f7',
    orbitPos: 'tr',
    orbitLabel: 'Personalised Almanac & Astrology',
    tagline: 'Plan Your Life',
    website: 'https://www.epanchang.com',
    blurb:
      'Your personalised almanac and astrology platform for guidance, insights into auspicious beginnings.',
    features: [
      'Panchang & Muhurats',
      'Horoscope & Astrology',
      'Vastu & Numerology',
      'Match Making',
      'Festivals & Rituals',
    ],
  },
  {
    id: 'happiffie',
    name: 'Happiffie',
    logo: img('happiffie-logo.png'),
    photo: img('Happiffie.png'),
    color: '#38bdf8',
    orbitPos: 'b',
    orbitLabel: 'AI Celebration Ecosystem',
    tagline: 'AI Celebration Ecosystem',
    website: 'https://www.happiffie.com',
    blurb:
      'AI-powered celebration ecosystem with venue discovery, planning tools, seamless experiences and integrated commerce.',
    features: [
      'Venue Discovery & Booking',
      'AI Planning & Recommendations',
      'Vendor Marketplace',
      'Event OS & Management',
      'Payments & Deals',
    ],
  },
  {
    id: 'marriage-colours',
    name: 'Marriage Colours',
    logo: img('MC__Logo.png'),
    photo: img('Marriage_colours.png'),
    color: '#ec4899',
    orbitPos: 'l',
    orbitLabel: 'Wedding Stories & Experiences',
    tagline: 'Wedding Stories & Experiences',
    website: 'https://www.marriagecolours.com',
    blurb:
      'Award-winning Wedding Planner & Decorator transforming weddings into unforgettable experiences.',
    features: [
      'Matrimony & Matchmaking',
      'Verified Profiles',
      'Family Connect',
      'Events & Workshops',
      'Success Stories',
    ],
  },
  {
    id: 'anantmaya',
    name: 'Anantmaya',
    logo: img('anantmaya_logo.png'),
    photo: img('Anantmaya.png'),
    color: '#d9a94e',
    orbitPos: 'r',
    orbitLabel: 'Soulful & Conscious Experiences',
    tagline: 'Soulful & Conscious Experiences',
    website: 'https://www.anantmaya.com',
    blurb:
      'Unique & Bespoke Wedding Invites, Return Gifts and Religious/Ritual Products.',
    features: [
      'Wellness Retreats',
      'Spiritual & Sacred Journeys',
      'Mindfulness & Healing',
      'Cultural Experiences',
      'Community & Learning',
    ],
  },
];

export const navLinks = [
  'Home',
  'About',
  'Journey',
  'Founder',
  'Innovation',
  'Impact',
  'Careers',
  'Insights',
  'Contact',
];

export const heroStats = [
  {
    icon: 'award',
    value: '15+',
    label: 'Years',
    sub: 'Building Meaningful Experiences',
  },
  {
    icon: 'sparkles',
    value: '500+',
    label: 'Experiences',
    sub: 'Across Life’s Important Moments',
  },
  {
    icon: 'heart',
    value: '5000+',
    label: 'Celebrations',
    sub: 'Enabled & Curated',
  },
  {
    icon: 'handshake',
    value: '25,000+',
    label: 'Partners',
    sub: 'Vendors, Creators & Experts',
  },
  {
    icon: 'smile',
    value: '4.8M+',
    label: 'Lives Touched',
    sub: 'Through Our Ecosystem',
  },
];

export const purpose = [
  {
    icon: 'heart',
    color: '#ec4899',
    title: 'We Celebrate',
    desc: 'Helping people create meaningful moments.',
  },
  {
    icon: 'camera',
    color: '#38bdf8',
    title: 'We Preserve',
    desc: 'Capturing memories and stories for generations.',
  },
  {
    icon: 'lightbulb',
    color: '#22c55e',
    title: 'We Guide',
    desc: 'Providing wisdom, insights, and direction.',
  },
  {
    icon: 'leaf',
    color: '#f59e0b',
    title: 'We Enrich',
    desc: 'Supporting personal growth and well-being.',
  },
  {
    icon: 'cpu',
    color: '#a855f7',
    title: 'We Innovate',
    desc: 'Building technology that amplifies human experiences.',
  },
];

export const journey = [
  {
    year: '2012',
    icon: 'flag',
    title: 'The Beginning',
    desc: 'A vision to transform celebrations and experiences.',
  },
  {
    year: '2012–2014',
    icon: 'map-pin',
    title: 'Venue Booking Innovation',
    desc: 'Early digital venue discovery and booking platform.',
  },
  {
    year: '2013',
    icon: 'heart',
    title: 'Marriage Colours & ePanchang',
    desc: 'Weddings, storytelling and personalized guidance.',
  },
  {
    year: '2015',
    icon: 'star',
    title: 'Premium Wedding Show',
    desc: 'Launch of Signature Weddings — first of its kind premium wedding show.',
  },
  {
    year: '2016',
    icon: 'camera',
    title: 'Atlhea Launch',
    desc: 'Wedding photography and cinematic films.',
  },
  {
    year: '2019',
    icon: 'leaf',
    title: 'Anantmaya Launch',
    desc: 'Spirituality, culture and conscious living.',
  },
  {
    year: '2020',
    icon: 'book',
    title: 'Industry E-books',
    desc: 'Launch of 5 e-books on Celebrations Industry trends — Venues, Weddings, Photo & Video, Invite & Stationery.',
  },
  {
    year: '2024',
    icon: 'cpu',
    title: 'Happiffie Launch',
    desc: 'AI-powered celebration ecosystem.',
  },
  {
    year: 'Future',
    icon: 'globe',
    title: 'Global Ecosystem Vision',
    desc: 'Building intelligent platforms that spread joy.',
  },
];

export const founderVision = [
  {
    icon: 'sparkles',
    title: 'Intelligent Celebrations',
    desc: 'Technology that simplifies celebrations.',
  },
  {
    icon: 'camera',
    title: 'Meaningful Memories',
    desc: 'Experiences that last beyond the event.',
  },
  {
    icon: 'leaf',
    title: 'Cultural Preservation',
    desc: 'Keeping traditions relevant for future generations.',
  },
  {
    icon: 'cpu',
    title: 'Human-Centric Technology',
    desc: 'AI that empowers, not replaces.',
  },
  {
    icon: 'trending-up',
    title: 'Purpose-Led Growth',
    desc: 'Creating value for customers, partners and communities.',
  },
];

export const footerCols = [
  {
    title: 'COMPANY',
    links: [
      'About Us',
      'Our Philosophy',
      'Leadership Team',
      'Careers',
      'Newsroom',
      'Contact Us',
    ],
  },
  {
    title: 'BRANDS',
    links: ['Happiffie', 'Marriage Colours', 'Anantmaya', 'Atlhea', 'ePanchang'],
  },
];
